import { Dot } from "./dot";

export class Stat {
    title: string;
    dots: Array<Dot>;
    total: number;
    constructor(data) {
        this.title = data.title;
        this.total = data.total;
        this.dots = data.dots.map(item => new Dot(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/stats/stat.ts